import { MenuItem, MenuItemProps } from "@mui/material";

import { useExecutionPanelContext } from "../ExecutionPanelContext";

/**
 * A single entry in the chat panel's overflow menu. Owns the menu's shared
 * styling and its dismiss-on-select behaviour, so entries only carry their own
 * action — including ones a surface adds through the `menuItems` slot, which
 * live outside this package.
 *
 * Takes plain `MenuItem` props; `sx` composes with the shared styling rather
 * than replacing it.
 */
export const ExecutionPanelMenuItem = ({
  sx,
  onClick,
  ...props
}: MenuItemProps) => {
  const { closeMenu } = useExecutionPanelContext();

  return (
    <MenuItem
      sx={[{ fontSize: 12 }, ...(Array.isArray(sx) ? sx : [sx])]}
      onClick={(event) => {
        // Dismiss first: an action that unmounts the panel (or steals focus,
        // like the Idea Library drawer) would otherwise leave the menu behind.
        closeMenu();
        onClick?.(event);
      }}
      {...props}
    />
  );
};
